import LoginPage from "views/Pages/LoginPage.js";
import ForgotPasswordPage from "views/Pages/ForgotPasswordPage.js";
import ChangePasswordPage from "views/Pages/ChangePasswordPage.js";
import UserProfile from "./views/Pages/UserProfile";

// @material-ui/icons

// var dashRoutes = navDynamic();

var dashRoutes = [
    {
        path: "/login-page",
        name: "Login Page",
        rtlName: "هعذاتسجيل الدخول",
        mini: "L",
        rtlMini: "هعذا",
        component: LoginPage,
        layout: "/auth",
        invisible: true
    },
    {
        path: "/forgotpassword",
        name: "Forgot Password",
        rtlName: "استعادة كلمة المرور",
        mini: "FP",
        rtlMini: "است",
        component: ForgotPasswordPage,
        layout: "/auth",
        invisible: true
    },
    {
        path: "/change-password",
        name: "Change Password",
        rtlName: "تغيير كلمة المرور",
        mini: "CP",
        rtlMini: "تغ",
        component: ChangePasswordPage,
        layout: "/auth",
        invisible: true
    },
    {
        path: "/user-page",
        name: "User Profile",
        rtlName: "Ù…Ù„Ù ØªØ¹Ø±ÙŠÙÙŠ Ù„Ù„Ù…Ø³ØªØ®Ø¯Ù…",
        mini: "UP",
        rtlMini: "Ø´Ø¹",
        component: UserProfile,
        layout: "/admin",
    }
];
export default dashRoutes;
